import React from 'react';
import PropTypes from 'prop-types';
import { compose, lifecycle, pure, withContext, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import createFocusDecorator from 'final-form-focus';
import { withRouter } from 'react-router-dom';

import * as actions from 'actions';

import { holdMutators } from 'utils';

import Form from './Form';
import { handlers, utils } from './shared';

const propTypes = {
  initialValues: PropTypes.shape({
    application: PropTypes.shape({
      borrower: PropTypes.objectOf(PropTypes.any),
      dataEntryStep: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      token: PropTypes.string,
      type: PropTypes.string,
    }),
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  updateApplicationSecondStep: PropTypes.func.isRequired,
};

const focusOnError = createFocusDecorator();

function PersonalFinancials({ initialValues, loading, updateApplicationSecondStep }) {
  return (
    <FinalForm
      onSubmit={updateApplicationSecondStep}
      initialValues={initialValues}
      subscription={{ mutators: true, submitting: true, pristine: true }}
      mutators={{ ...holdMutators }}
      decorators={[focusOnError]}
      loading={loading}
      component={Form}
    />
  );
}

PersonalFinancials.propTypes = propTypes;

function mapDispatchToProps(dispatch) {
  return {
    fetchApplicationSecondStep: bindActionCreators(actions.fetchApplicationSecondStep, dispatch),
    updateApplicationSecondStep: bindActionCreators(actions.updateApplicationSecondStep, dispatch),
  };
}

const enhance = compose(
  withRouter,
  connect(
    null,
    mapDispatchToProps,
  ),
  withState('loading', 'setLoading', false),
  withState('initialValues', 'setInitialValues', utils.setDefaultInitialValues()),
  withState('isFormDisabled', 'setIsFormDisabled', false),
  withHandlers({
    isFormDisabledSetter: handlers.isFormDisabledSetter,
  }),
  withHandlers({
    mergeInitialValues: handlers.mergeInitialValues,
  }),
  lifecycle({
    async componentDidMount() {
      const { match, fetchApplicationSecondStep, mergeInitialValues, setLoading } = this.props;
      const { token } = match.params;
      setLoading(true);
      await fetchApplicationSecondStep(token).then(mergeInitialValues);
      setLoading(false);
    },
  }),
  withContext(
    {
      isFormDisabled: PropTypes.bool,
    },
    ({ isFormDisabled }) => ({ isFormDisabled }),
  ),
  pure,
);

export default enhance(PersonalFinancials);
